'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';
import FormattedSize from 'I18n/components/FormattedSize';
import { connect } from 'react-redux';
import { getActiveAssetId } from 'DesignData/selectors/app';
import { getRawAssetSize } from 'DesignData/selectors/rawAssetBuffers';

const StatusBarFileSize = props => {
  const {
    size
  } = props;
  if (typeof size !== 'number') return null;

  const fileLabel = /*#__PURE__*/_jsx(FormattedSize, {
    value: size
  });

  return /*#__PURE__*/_jsx(StatusBarSection, {
    label: fileLabel
  });
};

export default connect(state => ({
  size: getRawAssetSize(state, {
    assetId: getActiveAssetId(state)
  })
}), null)(StatusBarFileSize);
StatusBarFileSize.propTypes = {
  size: PropTypes.number
};